export default {
  // list
  'crm_customer_parse_excel_config.query.fieldLabel': '字段标签',
  'crm_customer_parse_excel_config.query.fieldProperty': '字段属性名',
  'crm_customer_parse_excel_config.query.fieldLabel.placeholder': '请输入字段标签',
  'crm_customer_parse_excel_config.query.fieldProperty.placeholder': '请输入字段属性名',
  'crm_customer_parse_excel_config.query.excelCellNo': 'excel单元格坐标（例：A1、B1）',
  'crm_customer_parse_excel_config.query.excelCellNo.placeholder': '请输入excel单元格坐标（例：A1、B1）',
  'crm_customer_parse_excel_config.query.existColumn': '是否存在该列',
  'crm_customer_parse_excel_config.query.existColumn.placeholder': '请输入是否存在该列',
  'crm_customer_parse_excel_config.column.customerId': '客户ID',
  'crm_customer_parse_excel_config.column.fieldLabel': '字段标签',
  'crm_customer_parse_excel_config.column.fieldProperty': '字段属性名',
  'crm_customer_parse_excel_config.column.excelCellNo': 'excel单元格坐标',
  'crm_customer_parse_excel_config.column.existColumn': '是否存在该列',
  'crm_customer_parse_excel_config.column.defaultValue': '默认值/缺省值',
  'crm_customer_parse_excel_config.column.sortNo': '排序',
  'crm_customer_parse_excel_config.column.createBy': '创建人',
  'crm_customer_parse_excel_config.column.updateBy': '更新人',
  'crm_customer_parse_excel_config.column.createTime': '创建时间',
  'crm_customer_parse_excel_config.column.updateTime': '更新时间',
  'crm_customer_parse_excel_config.column.dataSource': '数据来源',
  'crm_customer_parse_excel_config.column.remark': '备注',
  'crm_customer_parse_excel_config.column.status': '状态',
  // edit
  'crm_customer_parse_excel_config.edit.title': '编辑客户解析excel账单配置',
  'crm_customer_parse_excel_config.add.title': '新增客户解析excel账单配置',
  'crm_customer_parse_excel_config.edit.success': '编辑成功',
  'crm_customer_parse_excel_config.add.success': '新增成功',
  'crm_customer_parse_excel_config.form.fieldLabel.required': '字段标签不能为空',
  'crm_customer_parse_excel_config.form.excelCellNo.required': 'excel单元格坐标（例：A1、B1）不能为空',
  'crm_customer_parse_excel_config.form.existColumn.required': '是否存在该列不能为空',
  'crm_customer_parse_excel_config.form.fieldProperty.required': '字段属性名不能为空',
  'crm_customer_parse_excel_config.form.fieldLabel': '字段标签',
  'crm_customer_parse_excel_config.form.fieldProperty': '字段属性名',
  'crm_customer_parse_excel_config.form.fieldLabel.placeholder': '请输入字段标签',
  'crm_customer_parse_excel_config.form.fieldProperty.placeholder': '请输入字段属性名',
  'crm_customer_parse_excel_config.form.excelCellNo': 'excel单元格坐标',
  'crm_customer_parse_excel_config.form.excelCellNo.placeholder': '请输入excel单元格坐标（例：A1、B1）',
  'crm_customer_parse_excel_config.form.existColumn': '是否存在该列',
  'crm_customer_parse_excel_config.form.existColumn.placeholder': '请输入是否存在该列',
  'crm_customer_parse_excel_config.form.defaultValue': '默认值/缺省值',
  'crm_customer_parse_excel_config.form.defaultValue.placeholder': '请输入默认值/缺省值',
  'crm_customer_parse_excel_config.form.remark': '备注',
  'crm_customer_parse_excel_config.form.remark.placeholder': '请输入备注',
}
